import { render } from "./Pagination.vue?vue&type=template&id=71f24466&ts=true"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71f24466"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71f24466', __exports__)) {
    api.reload('71f24466', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=71f24466&ts=true", () => {
    api.rerender('71f24466', render)
  })

}


export default __exports__